<div>
  <ng-container *ngIf="(showLoadingReplacingActivities$ | async) === false; else loading">
    <ng-container *ngIf="activitySections$ | async as activitySections">
      <ng-container *ngIf="activitySections.length > 0; else emptyActivities">
        <div class="section-container" *ngFor="let section of activitySections; trackBy: trackActivitySectionsBy">
          <div class="section-header-container">
            <h2 class="section-header-text">{{ section.name | translate }}</h2>
          </div>
          <ng-container *ngIf="crmIdentifiers$ | async as crmIdentifier">
            <ng-container *ngFor="let activity of section.activities; trackBy: trackActivitiesBy; let last = last">
              @if (hasCrmTimelineActivitiesFeatureFlag$ | async) {
                <crm-timeline-activity-v2
                  [activity]="activity"
                  [crmObjectIdentifier]="crmIdentifier"
                  [isLast]="last"
                  [showCopyLink]="showCopyLink()"
                ></crm-timeline-activity-v2>
              } @else {
                <crm-timeline-activity
                  [activity]="activity"
                  [crmObjectIdentifier]="crmIdentifier"
                  [isLast]="last"
                  [showCopyLink]="showCopyLink()"
                ></crm-timeline-activity>
              }
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="showLoadingAfterActivities$ | async">
        <glxy-loading-spinner></glxy-loading-spinner>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #loading>
  <glxy-loading-spinner></glxy-loading-spinner>
</ng-template>

<ng-template #emptyActivities>
  <ng-container *ngIf="{ filtersPristine: filtersPristine$ | async } as filtersPristineObj">
    <ng-container *ngIf="(loading$ | async) === false">
      <glxy-empty-state class="empty-state-container">
        <glxy-empty-state-hero>
          <img
            src="https://storage.googleapis.com/galaxy-libs-public-images/crm/activities-empty-state-v2.svg"
            [alt]="'CONTACT.ACTIVITIES_TIMELINE.EMPTY.IMAGE_ALT' | translate"
          />
        </glxy-empty-state-hero>
        <ng-container *ngIf="filtersPristineObj.filtersPristine; else emptyActivitiesSearchText">
          <glxy-empty-state-title>
            {{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY.HEADER' | translate }}
          </glxy-empty-state-title>
          <p>{{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY.HINT' | translate }}</p>
        </ng-container>
        <ng-template #emptyActivitiesSearchText>
          <glxy-empty-state-title>
            {{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY_SEARCH.HEADER' | translate }}
          </glxy-empty-state-title>
          <p>{{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY_SEARCH.HINT' | translate }}</p>
        </ng-template>
      </glxy-empty-state>
    </ng-container>
  </ng-container>
</ng-template>
